
import axios from 'axios';
var _API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRGV2ZWxvcG1lbnQgdG9rZW4iLCJwbGF0Zm9ybSI6ImRldiIsImFwcCI6IkRldmVsb3BtZW50In0.QXkohQ7lHeuS71xdcQJWa9_krUjtxFI4s1BqF1FkvW0';
// Prod URL baked in, like the rest of this file. VUE_APP_MODEL_API_URL is a dev-time
// override (.env.development.local points it at the /model-api proxy -> localhost:5001).
var _BASE_URL_PIXEL_MODEL = (process.env.VUE_APP_MODEL_API_URL || 'https://models.agroclimate.org') + '/model/';

const getPixelModelData = (context, params) => {
    const source = params.variable.id == 'arid' ? 'pixel' : 'acis';

    const paramsData = {
        "model": params.variable.id,
        "threshold": params.variable.threshold,
        "aggregation": "1D",
        "io": {
            "source": source,
            "interval": params.interval,
            "latitude": params.latitude,
            "longitude": params.longitude,
            "begin": params.begin,
            "end": params.end,
            "timezone": -5
        }
    };

    context.commit('SET_PIXEL_DATA_LOADING', true);

    return axios({
        method: 'post',
        url: _BASE_URL_PIXEL_MODEL + params.variable.id,
        headers: { 
            'x-api-key': _API_KEY,
        },
        data: paramsData
      }).then(response => {

        if (response.data.code == 'SUCCESS') {
            if (params.season == 'season')
                context.commit('SET_VARIABLE_PIXEL_DATA', { data: response.data.data, variable: {id: params.variable.id} } );
            else if(params.season == 'last')
                context.commit('SET_LAST_PIXEL_DATA', response.data.data);
            else if (params.variable.id.includes('His')) {
                context.commit('SET_HISTORICAL_PIXEL_DATA', response.data.data);
            }

        } else {
            context.commit('SET_VARIABLE_PIXEL_DATA', null);
            context.commit('SET_LAST_PIXEL_DATA', null);
        }
        context.commit('SET_PIXEL_DATA_LOADING', false);
    })
    .catch(e => {
        console.log(e);
        context.commit('SET_PIXEL_DATA_LOADING', false);
    });
    
};

export default {
    getPixelModelData
};